import { media } from './media';

export const v1 = {
  media,
};
